module.exports = __webpack_public_path__ + "img/pica_EN.1882b18d.png";